import type { QuoteStateType } from "~/shared/types/quote-details-types.ts";

// Custom hook to encapsulate complex loading logic for QuoteDetailsForm
export const useQuoteDetailsLoading = (
	quoteId: string | undefined,
	quoteState: QuoteStateType,
	shouldPerformQuoteOperations: boolean,
	pageDataIsFetching: boolean,
	shouldFetchQuote: boolean,
	isLoadingQuote: boolean,
	quoteIsFetched: boolean,
) => {
	// Determine loading states with clear, readable conditions
	const isNewQuote = !quoteId;
	const isExistingQuoteLoaded =
		quoteState.id && quoteState.id === Number(quoteId);
	const isFormResetForNewQuote = !quoteState.id || quoteState.id === 0;
	const isFormReady = isNewQuote
		? isFormResetForNewQuote
		: isExistingQuoteLoaded;

	const isLoading =
		pageDataIsFetching ||
		(shouldFetchQuote && isLoadingQuote && !quoteIsFetched) ||
		!isFormReady;

	return { isLoading, isFormReady };
};
